<template>
  <div class="popup z-index-10-fg confirmation small-popup rename-file-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Rename File</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div class="popup-body">
        <div class="primary-input input-item medium-item">
          <input type="text" v-model="newName" @keydown.enter="renameFile()" />
          <label>File Name</label>
        </div>
      </div>
      <div class="popup-footer">
        <button @click="$emit('closePopup')" class="text-btn">close</button>
        <button :disabled="isSaving" :class="{ 'square-btn': true, saving: isSaving }" @click="renameFile()">Save<img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import useAlerts from '@/composables/useAlerts';
import useLeadsQuery from '@/composables/useLeadsQuery';
import useLeadFiles from '@/composables/useLeadFiles';
import useContactFiles from '@/composables/useContactFiles';
import useLeadFilesQuery from '@/composables/useLeadFilesQuery';

export default {
  name: 'Rename File',
  emits: ['closePopup', 'refetchFiles'],
  props: {
    filename: {
      type: String,
      required: true,
    },
    leadid: {
      type: String,
      required: false,
    },
    contactid: {
      type: String,
      required: false,
    },
    companyid: {
      type: String,
      required: false,
    },
  },
  setup() {
    const { addAlert } = useAlerts();
    const { renameFile: renameLeadFile } = useLeadFiles();
    const { renameFile: renameContactFile } = useContactFiles();
    const { refetchLeadFiles } = useLeadFilesQuery();

    return {
      addAlert,
      leads: useLeadsQuery.leadsIncludingSingleLead,
      renameLeadFile,
      renameContactFile,
      refetchLeadFiles,
    };
  },
  data() {
    return {
      isSaving: false,
      newName: '',
      extension: '',
    };
  },
  methods: {
    async renameFile() {
      this.isSaving = true;
      const newNameWithExtension = this.newName + '.' + this.extension;

      let success;
      if (this.leadid) {
        success = await this.renameLeadFile(this.leadid, this.filename, newNameWithExtension);
      } else if (this.contactid) {
        success = await this.renameContactFile(this.contactid, 'contact', this.filename, newNameWithExtension);
      } else if (this.companyid) {
        success = await this.renameContactFile(this.companyid, 'company', this.filename, newNameWithExtension);
      }

      if (!success) {
        this.isSaving = false;
        this.$emit('closePopup');
        return;
      }

      // Refetch the files for this lead to get the updated file name
      if (this.leadid) {
        this.refetchLeadFiles(this.leadid);
      } else {
        this.$emit('refetchFiles');
        this.$emit('closePopup');
      }

      this.isSaving = false;
      this.addAlert('File renamed', 'low', 3);
      this.$emit('closePopup');
    },
  },
  watch: {
    newName() {
      this.newName = this.newName.replace(/[^a-zA-Z0-9!#$%&'.()\-\@^_`{}~ ]/g, '');
    },
  },
  mounted() {
    const extension = this.filename.split('.').pop();
    this.extension = extension;
    this.newName = this.filename.replace(`.${extension}`, '');
  },
};
</script>

<style lang="scss" scoped>
.rename-file-popup.small-popup {
  width: 30rem;

  .popup-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;
    margin-bottom: 1.5rem;

    .input-item {
      min-width: 20rem;
      flex: 1 0 45%;

      &.small-item {
        min-width: 5rem;
        flex: 1 0 10%;
      }

      &.large-item {
        min-width: 20rem;
        flex: 1 0 90%;
      }

      &.medium-item {
        min-width: 5rem;
        flex: 1 0 25%;
      }
    }
  }
}
</style>
